module.exports = __webpack_public_path__ + "img/icons-bundle.0e82d0826a231e2ee31aa14e7161b15c.svg";